// =============================================================================
// DIE-ICON-INIT.TS
// TS port of includes/js/die-icon-init.js (Wave 2a of plans/bundler-script-load-order-phase2.md —
// the FIRST early-tier Phase-2 fold). Renders <span class="js-die-icon" data-die="N"></span> markers
// (emitted by PHP die_icon()) into SVG sprite icons or a d100-style badge fallback.
//
// Auto-runs on DOMContentLoaded and observes the document for dynamic (AJAX-injected) markers. Exposes
// window.renderDieIcons(root) for callers that prefer explicit re-runs over relying on the observer
// (grep-confirmed: no cross-file callers today — the observer + DOMContentLoaded pass cover every site;
// the global is kept to mirror the original plain-<script>'s public surface 1:1).
//
// MODULE-SCOPE SAFE (clean 2a): the eval-time work — window.renderDieIcons attach, one initial
// renderDieIcons() pass, and a MutationObserver install on document.documentElement — is ALL pure DOM.
// It reads no template.js / core-helpers globals at module scope, so it's safe to run wherever the
// early-die-icon aggregate's <script> sits (same self-contained footer slot, ~338).
//
// Part of the gradual pivot to client-side icon rendering — see [[project_log_to_json_front_end]].
// =============================================================================

const VALID_DICE = new Set(['4', '6', '8', '10', '12', '20']);
const RENDERED_FLAG = 'data-rendered';
const ICON_STYLE = 'width:2em;height:2em;vertical-align:middle;';

function renderOne(el: HTMLElement): void {
    if (!el || el.getAttribute(RENDERED_FLAG) === 'true') return;
    const die = (el.dataset.die || '').trim();
    if (VALID_DICE.has(die)) {
        el.innerHTML =
            '<svg class="svg-icon" aria-hidden="true" style="' + ICON_STYLE + '">' +
            '<use href="#dice-d' + die + '"></use></svg>';
    } else {
        // Fallback for d100 and other non-physical-die sides
        const safe = die.replace(/[^A-Za-z0-9]/g, '');
        el.innerHTML = '<span class="badge bg-dark">d' + safe + '</span>';
    }
    el.setAttribute(RENDERED_FLAG, 'true');
}

function renderDieIcons(root?: Element | Document): void {
    const scope = root || document;
    scope.querySelectorAll<HTMLElement>('.js-die-icon:not([' + RENDERED_FLAG + '="true"])').forEach(renderOne);
}

declare global {
    interface Window {
        renderDieIcons: typeof renderDieIcons;
    }
}

window.renderDieIcons = renderDieIcons;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { renderDieIcons(); });
} else {
    renderDieIcons();
}

// Catch AJAX-injected fragments without each caller having to remember to
// re-run the renderer. Cheap — only inspects added nodes.
const observer = new MutationObserver(function (mutations: MutationRecord[]) {
    for (const m of mutations) {
        for (const node of Array.from(m.addedNodes)) {
            if (!(node instanceof Element)) continue;
            if (node instanceof HTMLElement && node.classList.contains('js-die-icon')) {
                renderOne(node);
            } else {
                node.querySelectorAll<HTMLElement>('.js-die-icon:not([' + RENDERED_FLAG + '="true"])').forEach(renderOne);
            }
        }
    }
});
observer.observe(document.documentElement, { childList: true, subtree: true });

export {};
